<template>
  <ul class="p-g01-content-button-list">
    <li
      v-for="(category, key) in categories"
      :key="key"
      class="p-g01-content-button-list__item"
    >
      <a
        href="#"
        :id="'btn_' + category.category_id"
        @click="onClick($event, category.category_id)"
        v-scroll-to="`#ex-${category.category_id}`"
        class="p-g01-content-button-list__item__link"
        :class="{ inactive: category.sku_set.length == 0 }"
      >
        <template>
          <IconItemCategory
            v-if="isCategory"
            :id="category.category_id"
            class="p-g01-content-button-list__item__icon"
          />
          <IconPoint
            v-else
            :icon-size="24"
            class="p-g01-content-button-list__item__icon"
          />
        </template>
        <template v-if="isCategory">
          <span class="p-g01-content-button-list__item__label">
            {{ category.category_name }}
          </span>
        </template>
        <template v-else>
          <p
            class="p-g01-content-button-list__item__label p-g01-content-button-list__item__label--point"
          >
            {{ category.category_name }}
          </p>
        </template>
        <IconBase
          view-box="0 0 24 24"
          width="24"
          height="24"
          color="#b6b6b6"
          class="p-g01-content-button-list__item__arrow"
        >
          <IconArrowBottom />
        </IconBase>
      </a>
    </li>
  </ul>
</template>

<script lang="ts">
import IconItemCategory from "@/common/components/icons/IconItemCategory.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowBottom from "@/common/components/icons/IconArrowBottom.vue";
import IconPoint from "@/common/components/icons/IconPoint.vue";
import { Options, Vue } from 'vue-class-component';
import commons from "@/common/store/modules/commons";
import vuescroll from "vue-scrollto";

@Options({
  props: {
	categories: { type: Array, required: true, default: () => ([]) },
	isCategory: { type: Boolean, required: true, default: true }
  },
  components: {
    IconItemCategory,
    IconBase,
    IconArrowBottom,
    IconPoint
  }
})
export default class G01ContentButtonList extends Vue {
  categories!: any;
  isCategory!: boolean;

  get colorCode() {
    return commons?.OrgPageSpecific?.page_color;
  }
  get unit() {
    return commons?.OrgPageSpecific?.point_name;
  }

  get isPointRangeFirst() {
    return function(id: any) {
      return id === "item-point-range0";
    };
  }
  get isPointRangeLast() {
    return function(id: any) {
      return id === "item-point-range5";
    };
  }

  onClick(event: any, id: any) {
    const divId = "ex-" + id;
    const div = document.getElementById(divId);
    if (div == null) {
      const btn = document.getElementById("btn_" + id);
      btn ? (btn.style.backgroundColor = "#ddd6d6") : "";
    } else {
      const buttons: any = document.getElementsByClassName(
        "p-g01-content-button-list__item__link"
      );
      const buttonCount = buttons.length;

      for (let i = 0; i < buttonCount; i++) {
        buttons[i].style.backgroundColor = "";
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.p-g01-content-button-list {
  display: flex;
  flex-wrap: wrap;
  margin: rem(-16) rem(-8) 0;

  @include large-sp {
    margin: rem(-8) rem(-4) 0;
  }

  &__item {
    width: calc(100% / 4 - 1rem);
    margin: rem(16) rem(8) 0;
    height: rem(40);

    @include large-sp {
      width: calc(100% / 3 - 0.5rem);
      margin: rem(8) rem(4) 0;
    }

    &__link {
      @include text__body--m;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      border: px(1) solid $common-gray300;
      border-radius: px(4);
      background-color: $common-white;
      padding: 0 rem(16);

      &.inactive {
        cursor: default;
        opacity: 0.5;
      }

      @include large-pc {
        font-weight: bold;
      }

      @include large-sp {
        @include text__body--xs;
        line-height: rem(14);
        padding: 0 rem(4);
        justify-content: center;
        text-align: center;
      }
    }

    &__icon {
      @include large-sp {
        display: none;
      }
    }

    &__label {
      &--point {
        font-family: $font--roboto;
      }
    }

    &__arrow {
      @include large-sp {
        display: none;
      }
    }
  }
}
</style>
